import { type QueryObserverOptions, useQuery } from '@tanstack/react-query';

import FunctionKey from 'constants/functionKey';
import { useChainId, usePublicClient } from 'libs/wallet';
import type { ChainId } from 'types';
import type { Address } from 'viem';
import { type GetVTokenCashOutput, getVTokenCash } from '.';

interface TrimmedInput {
  vTokenAddress: Address;
}

export type UseGetVTokenCashQueryKey = [
  FunctionKey.GET_V_TOKEN_CASH,
  {
    chainId: ChainId;
    vTokenAddress: Address;
  },
];

type Options = QueryObserverOptions<
  GetVTokenCashOutput,
  Error,
  GetVTokenCashOutput,
  GetVTokenCashOutput,
  UseGetVTokenCashQueryKey
>;

export const useGetVTokenCash = ({ vTokenAddress }: TrimmedInput, options?: Partial<Options>) => {
  const { chainId } = useChainId();
  const { publicClient } = usePublicClient();

  return useQuery({
    queryKey: [FunctionKey.GET_V_TOKEN_CASH, { chainId, vTokenAddress }],
    queryFn: () => getVTokenCash({ publicClient, vTokenAddress }),
    ...options,
  });
};
